<template>
  <div class="container" >
    <ul class="info">
      <li class="info-container">
        <p class="info-label" >患者姓名：</p>
        <p class="info-value" >{{ info.patientName }}</p>
      </li>
      <li class="info-container">
        <p class="info-label" >账号状态：</p>
        <p class="info-value" :style="{ 'color' : accountStatusName(info.accountStatus).color || '' }" >{{ accountStatusName(info.accountStatus).value || "" }}</p>
      </li>
      <li class="info-container">
        <p class="info-label" >手机号：</p>
        <p class="info-value" >{{ info.phone }}</p>
      </li>
      <li class="info-container">
        <p class="info-label" >性别：</p>
        <p class="info-value" >{{ genderName(info.gender) }}</p>
      </li>
      <li class="info-container">
        <p class="info-label" >年龄：</p>
        <p class="info-value" >{{ info.age ? `${info.age}岁` : "" }}</p>
      </li>
      <li class="info-container">
        <p class="info-label" >管理医生：</p>
        <p class="info-value" >{{ info.doctorName }}</p>
      </li>
      <li class="info-container">
        <p class="info-label" >患者分组：</p>
        <p class="info-value" >{{ info.patientGroup }}</p>
      </li>
    </ul>
    <div class="data-tab">
      <el-tabs v-model="activeName">
        <template v-for="(item,index) in tabsList" >
          <el-tab-pane :label="item.label" :name="item.name" :key="index" >
            <component :is="item.component" :patientOpenid="patientOpenid" />
          </el-tab-pane>
        </template>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ComparisonData from "./components/ComparisonData/index.vue";
import OperationLog from "./components/OperationLog/index.vue";
export default {
  name: "PatientManageDetails",
  components: {
    ComparisonData,
    OperationLog,
  },
  data() {
    return {
      gender: [
        {
          key: '0',
          value: "女"
        },
        {
          key: '1',
          value: "男"
        }
      ],
      activeName: "0",
      tabsList: [
        {
          name: "0",
          label: "对照数据",
          component: ComparisonData,
        },
        {
          name: "1",
          label: "操作日志",
          component: OperationLog,
        }
      ]
    };
  },
  computed: {
    patientOpenid() {
      return this.$route.query.patientOpenid;
    },
    info() {
      return {...this.$route.query};
    },
    accountStatusName() {
      return (e) => {
        const obj = (this.$store.state.accountStatusDict || []).find(item => item.key === e) || {};
        return obj;
      }
    },
    genderName() {
      return (e) => {
        const obj = (this.gender || []).find(item => item.key === e) || {};
        return obj.value || "";
      }
    },
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
.container{
  .info{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 30px;
    background: #FFFFFF;
    border-radius: 6px;
    margin-bottom: 15px;
    &-container{
      width: calc(100% / 5);
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      &-label{
        width: 120px;
        color: #3D3D3D;
      }
      &-value{
        color: #3D3D3D;
      }
    }
    &-container:nth-last-child(1),&-container:nth-last-child(2) {
      margin-bottom: 0;
    }
  }
  .data-tab{
    padding: 15px;
    background: #FFFFFF;
    border-radius: 6px;
  }
}
</style>
